/* eslint-disable react/no-array-index-key */
import {
  Box,
  Hidden,

  //   IconButton,
  Stack,
  Typography
} from '@mui/material';

import React from 'react';
import i18n from '@utils/i18n';
import gradient from 'assets/images/gradient.png';
import RowLayout from '@components/RowLayout';
import env from '@constants/env';

const chilsung = `${env.s3BaseUrl}/landing-page/homepage/logos/chilsung.png`;
const ventures = `${env.s3BaseUrl}/landing-page/homepage/logos/ventures.png`;

const kosme = `${env.s3BaseUrl}/landing-page/homepage/logos/kosme.png`;
const credit = `${env.s3BaseUrl}/landing-page/homepage/logos/credit.png`;
const infobank = `${env.s3BaseUrl}/landing-page/homepage/logos/infobank.png`;
const hyu = `${env.s3BaseUrl}/landing-page/homepage/logos/hyu.png`;

const cj = `${env.s3BaseUrl}/landing-page/homepage/logos/cj.png`;
const roi = `${env.s3BaseUrl}/landing-page/homepage/logos/roi.png`;

const Together = () => {
  const t = i18n.getFixedT(null, null, '');

  return (
    <RowLayout
      sx={{
        height: 'auto',
        backgroundColor: '#FFFFFF',
        alignItems: 'center',
        justifyContent: 'flex-start',
        minHeight: { md: '897px', xs: 'auto' },
        pt: { md: '150px', xs: '60px' },
        pb: { md: '250px', xs: '80px' },
        position: 'relative'
      }}
    >
      <Hidden mdDown>
        <Box
          component="img"
          src={gradient}
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',

            zIndex: 50
          }}
        />
        <Stack
          sx={{
            width: { md: '75%', lg: '100%' },
            height: '100%',
            maxWidth: '1920px',
            px: { lg: '320px' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Stack
            textAlign="left"
            gap={3}
            sx={{ width: '100%' }}
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="100"
            data-aos-duration="300"
            data-aos-once="true"
          >
            <Typography
              variant="sectionChip"
              sx={{
                fontSize: '32px',
                fontFamily: 'Swear Display',
                fontWeight: 500,
                fontStyle: 'italic',
                lineHeight: '100%',
                letterSpacing: '-1.6px'
              }}
            >
              Together
            </Typography>
            <Stack sx={{ gap: 5 }}>
              <Typography
                fontWeight={700}
                fontFamily="Pretendard"
                sx={{
                  color: '#000',
                  fontSize: 48,
                  letterSpacing: '-2.4px',
                  lineHeight: '100%'
                }}
              >
                {t('pages.flagshop.together.title')}
              </Typography>
              <Typography
                fontWeight={500}
                fontFamily="Pretendard"
                sx={{
                  color: '#000',
                  fontSize: 18,
                  letterSpacing: '-0.9px',
                  lineHeight: '100%'
                }}
              >
                {t('pages.flagshop.together.subtitle')}
              </Typography>
            </Stack>
          </Stack>
          <Stack
            id="grid"
            sx={{
              mt: '191px',
              height: '100%',
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="200"
            data-aos-duration="300"
            data-aos-once="true"
          >
            {/* 1st row */}
            <Stack
              sx={{
                minHeight: '100px',

                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '329px'
              }}
            >
              <Stack
                sx={{
                  height: '100%',
                  minHeight: '100px',

                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <img src={chilsung} alt="chilsung log" />
              </Stack>

              <Stack
                sx={{
                  height: '100%',
                  minHeight: '100px',

                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <img
                  src={ventures}
                  alt="ventures log"
                  style={{ marginBottom: '11px' }}
                />
              </Stack>
            </Stack>

            {/* 2nd row */}

            <Stack
              sx={{
                minHeight: '100px',

                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Stack
                sx={{
                  height: '100%',
                  minHeight: '100px',

                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: '20px'
                }}
              >
                <img src={kosme} alt="kosme logo" />
              </Stack>

              <Stack
                sx={{
                  height: '100%',
                  minHeight: '100px',
                  ml: '150px',
                  alignItems: 'center',
                  justifyContent: 'flex-end'
                }}
              >
                <img
                  src={credit}
                  alt="credit log"
                  style={{ marginBottom: '0px' }}
                />
              </Stack>

              <Stack
                sx={{
                  height: '100%',
                  minHeight: '100px',
                  ml: '150px',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <img
                  src={infobank}
                  alt="credit log"
                  style={{ marginBottom: '0px' }}
                />
              </Stack>

              <Stack
                sx={{
                  height: '100%',
                  minHeight: '100px',
                  ml: 'auto',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <img
                  src={hyu}
                  alt="credit log"
                  style={{ marginBottom: '0px' }}
                />
              </Stack>
            </Stack>

            {/* 2nd row */}
            <Stack
              sx={{
                minHeight: '100px',
                mt: '20px',
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start'
              }}
            >
              <Stack
                sx={{
                  height: '100%',
                  minHeight: '100px',
                  ml: '150px',
                  mr: '280px',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <img src={cj} alt="cj log" style={{ marginBottom: '11px' }} />
              </Stack>

              <Stack
                sx={{
                  height: '100%',
                  minHeight: '100px',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: '90px !important'
                }}
              >
                <img src={roi} alt="roi log" />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Hidden>
      <Hidden mdUp>
        <Box
          component="img"
          src={gradient}
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            height: { xs: '80px', sm: '140px' },

            zIndex: 50
          }}
        />
        <Stack
          sx={{
            width: '100%',
            height: '100%',

            px: { xs: '20px', sm: '40px' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <Stack
            textAlign="left"
            gap={3}
            sx={{ width: '100%' }}
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="100"
            data-aos-duration="300"
            data-aos-once="true"
          >
            <Typography
              variant="sectionChip"
              sx={{
                fontSize: '32px',
                fontFamily: 'Swear Display',
                fontWeight: 500,
                fontStyle: 'italic',
                lineHeight: '100%',
                letterSpacing: '-1.6px'
              }}
            >
              Together
            </Typography>
            <Stack sx={{ gap: 5 }}>
              <Typography
                fontWeight={700}
                fontFamily="Pretendard"
                sx={{
                  color: '#000',
                  fontSize: { xs: 30, sm: 48 },
                  letterSpacing: { xs: '-1.5px', sm: '-2.4px' },
                  lineHeight: '130%',
                  wordBreak: 'keep-all', // Prevent breaking words
                  overflowWrap: 'break-word' // Handle long words
                }}
              >
                {t('pages.flagshop.together.title')}
              </Typography>
              <Typography
                fontWeight={500}
                fontFamily="Pretendard"
                sx={{
                  color: '#000',
                  fontSize: 18,
                  letterSpacing: '-1.08px',
                  lineHeight: '130%',
                  wordBreak: 'keep-all', // Prevent breaking words
                  overflowWrap: 'break-word' // Handle long words
                }}
              >
                {t('pages.flagshop.together.subtitle')}
              </Typography>
            </Stack>
          </Stack>
          {/* mobile */}
          <Stack
            id="grid"
            sx={{
              mt: '90px',
              height: '100%',
              width: '100%',
              display: { xs: 'flex', sm: 'none' },
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="200"
            data-aos-duration="300"
            data-aos-once="true"
          >
            {/* 1st row */}
            <Stack
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: { xs: 'row', sm: 'row-reverse' },
                gap: { xs: '22px', sm: '60px' },
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Stack
                sx={{
                  height: '100%',

                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Box
                  component="img"
                  src={ventures}
                  alt="ventures log"
                  sx={{
                    height: { xs: '34px', sm: '58px' },
                    width: { xs: '117px', sm: '198px' }
                  }}
                />
              </Stack>

              <Stack
                sx={{
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Box
                  component="img"
                  src={chilsung}
                  alt="chilsung log"
                  sx={{
                    height: { xs: '30px', sm: '49px' },
                    width: { xs: '121px', sm: '205px' },
                    mb: { xs: '12px', sm: '30px' }
                  }}
                />
              </Stack>
            </Stack>

            {/* 2nd row */}

            <Stack
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Stack
                sx={{
                  height: '100%',

                  alignItems: 'center',
                  justifyContent: 'center',
                  mt: { xs: '20px', sm: '60px' }
                }}
              >
                <Box
                  component="img"
                  src={kosme}
                  alt="kosme logo"
                  sx={{
                    height: { xs: '39px', sm: '69px' },
                    width: { xs: '112px', sm: '185px' }
                  }}
                />
              </Stack>

              <Stack
                sx={{
                  height: '100%',
                  mr: '40px',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Box
                  component="img"
                  src={infobank}
                  alt="credit log"
                  sx={{
                    marginBottom: '40px',
                    width: { xs: '101px', sm: '219px' },
                    height: '60px'
                  }}
                />
              </Stack>
            </Stack>

            <Stack
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <img
                src={credit}
                alt="credit log"
                style={{
                  marginBottom: '0px',
                  marginLeft: '60px',
                  width: '132px',
                  height: '27px'
                }}
              />
            </Stack>
            {/* 2nd row */}

            <Stack
              sx={{
                mt: '20px',
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              {' '}
              <Stack
                sx={{
                  height: '100%',
                  ml: '20px',
                  alignItems: 'center'
                }}
              >
                <img
                  src={hyu}
                  alt="credit log"
                  style={{
                    marginTop: '-50px',
                    width: '112px',
                    height: '36px'
                  }}
                />
              </Stack>
              <Stack
                sx={{
                  height: '100%',

                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: '30px !important'
                }}
              >
                <img
                  src={roi}
                  alt="roi log"
                  style={{ width: '150px', height: '56px' }}
                />
              </Stack>
            </Stack>

            <Stack
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start'
              }}
            >
              <Stack
                sx={{
                  height: '100%',

                  ml: '80px',

                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <img
                  src={cj}
                  alt="cj log"
                  style={{
                    marginBottom: '11px',
                    width: '120px',
                    height: '40px'
                  }}
                />
              </Stack>
            </Stack>
          </Stack>

          {/* tablet */}
          {/* mobile */}
          <Stack
            id="grid"
            sx={{
              mt: { xs: '90px', sm: '166px' },
              height: '100%',
              width: '100%',
              display: { xs: 'none', sm: 'flex' },
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="200"
            data-aos-duration="300"
            data-aos-once="true"
          >
            {/* 1st row */}
            <Stack
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: { xs: 'row', sm: 'row-reverse' },
                gap: { xs: '22px', sm: '60px' },
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Stack
                sx={{
                  height: '100%',

                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Box
                  component="img"
                  src={ventures}
                  alt="ventures log"
                  sx={{
                    height: { xs: '34px', sm: '58px' },
                    width: { xs: '117px', sm: '198px' }
                  }}
                />
              </Stack>

              <Stack
                sx={{
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Box
                  component="img"
                  src={chilsung}
                  alt="chilsung log"
                  sx={{
                    height: { xs: '30px', sm: '49px' },
                    width: { xs: '121px', sm: '205px' },
                    mb: { xs: '12px', sm: '30px' }
                  }}
                />
              </Stack>
            </Stack>

            {/* 2nd row */}

            <Stack
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Stack
                sx={{
                  height: '100%',

                  alignItems: 'center',
                  justifyContent: 'center',
                  mt: { xs: '20px', sm: '60px' }
                }}
              >
                <Box
                  component="img"
                  src={kosme}
                  alt="kosme logo"
                  sx={{
                    height: { xs: '39px', sm: '69px' },
                    width: { xs: '112px', sm: '185px' }
                  }}
                />
              </Stack>

              <Stack
                sx={{
                  height: '100%',
                  ml: '20px',
                  alignItems: 'center'
                }}
              >
                <Box
                  component="img"
                  src={hyu}
                  alt="credit log"
                  style={{
                    marginTop: '-0px',
                    width: '186px',
                    height: '59px'
                  }}
                />
              </Stack>
            </Stack>

            <Stack
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Box
                component="img"
                src={credit}
                alt="credit log"
                style={{
                  marginTop: '-20px',
                  marginLeft: '30px',
                  width: '219px',
                  height: '43px'
                }}
              />
            </Stack>
            {/* 2nd row */}

            <Stack
              sx={{
                mt: '20px',
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Stack
                sx={{
                  height: '100%',

                  ml: '60px',

                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Box
                  component="img"
                  src={cj}
                  alt="cj log"
                  style={{
                    marginBottom: '11px',
                    width: '197px',
                    height: '62px'
                  }}
                />
              </Stack>
              <Stack
                sx={{
                  height: '100%',
                  mr: '40px',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Box
                  component="img"
                  src={infobank}
                  alt="credit log"
                  sx={{
                    marginBottom: '40px',
                    width: { xs: '101px', sm: '172px' },
                    height: '103px'
                  }}
                />
              </Stack>{' '}
            </Stack>

            <Stack
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Stack
                sx={{
                  height: '100%',

                  alignItems: 'center',
                  justifyContent: 'center',
                  mt: '-40px',
                  ml: '100px !important',
                  mb: '50px'
                }}
              >
                <img
                  src={roi}
                  alt="roi log"
                  style={{ width: '250px', height: '96px' }}
                />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Hidden>
    </RowLayout>
  );
};

export default Together;
